import merge from 'deepmerge'
import baseRoutes from '../modules/base/routes'
import marcaRoutes from '../modules/marca/routes'
import proveedorRoutes from '../modules/proveedor/routes'
import depositoRoutes from '../modules/deposito/routes'
import modeloRoutes from '../modules/modelo/routes'
import tamanioRoutes from '../modules/tamanio/routes'
import productoRoutes from '../modules/producto/routes'
import recargoRoutes from '../modules/recargo/routes'
import movimientoRoutes from '../modules/movimiento/routes'
import dashboardRoutes from '../modules/dashboard/routes'
import userConfigurationRoutes from '../modules/user-configuration/routes'
import ofertaRoutes from '../modules/oferta/routes'
import facturacionRoutes from '../modules/facturacion/routes'
import clienteRoutes from '../modules/cliente/routes'
import registroActividadRoutes from '../modules/registro-actividades/routes'
import mediaRoutes from '../modules/media/routes'
import importarProductosRoutes from '../modules/importar-productos/routes'
import compararPreciosProveedorRoutes from '../modules/comparar-precios-proveedor/routes'
import importarListaPreciosRoutes from '../modules/importar-lista-precios/routes'
import ventasRoutes from '../modules/ventas/routes'
import comprasRoutes from '../modules/compras/routes'
import listaPreciosVentaRoutes from '../modules/lista-precios-venta/routes'

import { routes as userRoutes } from '@dracul/user-frontend'
import { routes as customRoutes } from '@dracul/customize-frontend'
import { routes as notificationRoutes } from '@dracul/notification-frontend'
import profileOverrideRoutes from '../modules/base/routes/profileOverride'

const routes = merge.all(
    [
        baseRoutes,
        productoRoutes,
        tamanioRoutes,
        modeloRoutes,
        marcaRoutes,
        proveedorRoutes,
        recargoRoutes,
        depositoRoutes,
        movimientoRoutes,
        dashboardRoutes,
        userConfigurationRoutes,
        ofertaRoutes,
        facturacionRoutes,
        clienteRoutes,
        registroActividadRoutes,
        mediaRoutes,
        importarProductosRoutes,
        compararPreciosProveedorRoutes,
        importarListaPreciosRoutes,
        ventasRoutes,
        comprasRoutes,
        listaPreciosVentaRoutes,
        profileOverrideRoutes,
        userRoutes,
        notificationRoutes,
        customRoutes
    ]
)


export default routes;
